<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="900px"
      v-bind:body-style="{ height: '480px' }"
    >
    <!-- 内容 -->
    <div class="investment_warp">
      <!-- 提示 -->
      <a-alert :message="alertMessage" type="warning" show-icon />
      <!-- 按钮 -->
      <a-button type="primary" ghost @click="selectFn()" style="margin-top: 15px;">选择商品</a-button >
      <!-- 表格 -->
      <a-table
        v-if="tableVisible"
        class="antd-table"
        bordered
        :columns="relevanceBatch_grid.field"
        :data-source="relevanceBatch_grid.row"
        rowKey="id"
        size="small"
        :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
        :pagination="false"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
        </span>
        <!-- 数量 -->
        <span slot="number" slot-scope="text, record, index">
          <a-input-number placeholder="请输入" v-model="record.number" @change="numberChange(record.number,index)" style="width: 100px;"></a-input-number>
        </span>
        <!-- 更多操作 -->
        <span slot="operation" slot-scope="data" class="ellipsis">
          <a-button type="primary" ghost @click="handle_detele(data.id)">删除</a-button>
        </span>
      </a-table>

      <!-- 列表 -->

      <!-- 底部 -->
      <div class="table_bottom">
        <!-- 按钮 -->
        <!-- <div class="bottom_btn">
          <a-button type="primary" @click="handle_all" class="btn_first">选择全部</a-button>
          <a-button type="primary" ghost  @click="handle_reverse">反向选择</a-button>
        </div> -->

        <!-- 分页 -->
        <!-- <div>
          <a-pagination
            class="table_pagination"
            show-size-changer
            :default-current="1"
            v-model="pageParam.pageNum"
            :show-total="(total) => `共 ${total} 条`"
            :page-size-options="pageSizeOptions"
            size="small"
            :total="total"
            @showSizeChange="onShowSizeChange"
            @change="paginationChange"
            :page-size.sync="pageParam.pageSize"
          />
        </div> -->
      </div>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>

    <!-- 表单 -->
    <selectModal
      v-if="selectVisible"
      :modalTitle="selectModalTitle"
      @close="close" 
      @handleOk="selectlHandleOk"
    ></selectModal>
  </div>
</template>

<script>
import selectModal from "./select-modal.vue";
import {
  queryCustom
} from "@/api/api.js";
export default {
  components: {
    selectModal
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "撤销赎回",
    }, //标题
    modalContent: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      visible: true,
      tableVisible:true,

      alertMessage:"",

      //搜索栏
      filterData: [
        {
          name: "custName",
          type: "input",
          value: undefined,
          label: "请输入客户名称",
          placeholder:"客户名称：",
        },
      ],
      relevanceBatch_grid: {
        height: "290px",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 50,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品名称",
            align: "center",
            width: 240,
            dataIndex: "goodsName",
            ellipsis: true,
          },
          {
            title: "赠送数量",
            align: "center",
            width: 60,
            dataIndex: "number",
            ellipsis: true,
            scopedSlots: {
              customRender: "number",
            },
          },
          {
            title: "操作",
            width: 80,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      paramsObj: {
        custName: null,
        custNo: null,
      },
      list: [],

      //弹窗
      selectVisible: false,
      selectModalTitle: "",
      okLoad: false,
    }
  },
  mounted() {
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });

    //提示内容
    this.alertMessage = "您正在给";
    this.modalContent.forEach(item => {
      this.alertMessage = this.alertMessage + "[" + item.custName + "]、"
    });
    this.alertMessage = this.alertMessage.substr(0, this.alertMessage.length - 1);
    this.alertMessage = this.alertMessage + "赠送以下权益。"
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },
    //保存
    handleOk() {
      // this.relevanceBatch_grid.row.forEach(item => {
      //   if(item)
      // })
      //校验数量是否为空
      for (let i = 0; i < this.relevanceBatch_grid.row.length; i++){
        if (this.relevanceBatch_grid.row[i].number == "" || this.relevanceBatch_grid.row[i].number == undefined || this.relevanceBatch_grid.row[i].number == null) {
          return this.$message.warning("数量不能为空！");
        }
      }
      if (this.relevanceBatch_grid.row.length < 1) {
        return this.$message.warning("请选择商品！")
      }
      this.okLoad = true
      this.$emit("handleOk", this.relevanceBatch_grid.row); 
    },
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    //选择商品
    selectFn() {
      this.selectVisible = true;
      this.selectModalTitle = "选择商品"
    },

    //关闭弹窗
    close() {
      this.selectVisible = false;
    },

    //弹窗确认
    selectlHandleOk(data) {
      this.selectVisible = false;
      //加入数量
      data.forEach(item => {
        item['number'] = 1;
      })
      let obj = this.relevanceBatch_grid.row;
      this.relevanceBatch_grid.row = obj.concat(data);
      //根据id去重
      this.relevanceBatch_grid.row = [...new Set(this.relevanceBatch_grid.row.map(item => item.id))].map(id => this.relevanceBatch_grid.row.find(item => item.id === id));
    },

    //删除
    handle_detele(id) {
      this.relevanceBatch_grid.row = this.relevanceBatch_grid.row.filter(item => item.id !== id)
    },

    //重新渲染表格
    numberChange(value,index) {
      this.tableVisible = false;
      if (Number(value) <= 0) {
        this.$message.warning("请输入大于0的数！");
        this.relevanceBatch_grid.row[index].number = 1;
      }
      if (!Number.isInteger(value)) {
        this.$message.warning("请输入整数！");
        this.relevanceBatch_grid.row[index].number = 1;
      }
      this.tableVisible = true;
    }


  },
}
</script>

<style scoped lang="less">

.message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.antd-table{
  margin-top: 10px;
}

.table_bottom{
  float: right;
  margin-top: 10px;

.bottom_btn{
  margin-top: 10px;

  .btn_first{
    margin-right: 10px;
  }
}



}
</style>
